import { useState } from "react";

export const LARDER_CATEGORIES = ["Produce", "Dairy & Eggs", "Meat & Fish", "Bread & Grains", "Pantry Staples", "Herbs & Spices", "Other"];
const EMPTY = { name: "", quantity: "", unit: "", category: "Produce", notes: "", low_at: "", remind: false };
const num = (v) => { if (v === "" || v === null || v === undefined) return null; const n = Number(v); return Number.isFinite(n) ? n : null; };

// Add / edit form for one larder or shopping-list item. Quantity is optional; nothing is guessed. `stock` adds the low-stock fields.
export function LarderForm({ initial, onSubmit, onCancel, busy, testid = "larder-form", stock = false, submitLabel }) {
  const [f, setF] = useState(initial ? { ...EMPTY, ...initial, quantity: initial.quantity ?? "", unit: initial.unit || "", notes: initial.notes || "", low_at: initial.low_at ?? "", remind: !!initial.remind } : EMPTY);
  const set = (k) => (e) => setF(s => ({ ...s, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));
  const submit = (e) => {
    e.preventDefault();
    const b = { name: f.name, quantity: num(f.quantity), unit: f.unit || null, category: f.category, notes: f.notes || null };
    onSubmit(stock ? { ...b, low_at: num(f.low_at), remind: f.remind } : b);
  };
  return (
    <form onSubmit={submit} className="fs-card p-5 grid gap-3 sm:grid-cols-6" data-testid={testid}>
      <label className="sm:col-span-3 text-xs tracking-widest uppercase fs-text-2">Item
        <input className="fs-input mt-1 normal-case tracking-normal" required maxLength={80} value={f.name} onChange={set("name")} placeholder="e.g. Maple syrup" data-testid={`${testid}-name`} />
      </label>
      <label className="text-xs tracking-widest uppercase fs-text-2">Qty
        <input className="fs-input mt-1" type="number" min="0" step="any" value={f.quantity} onChange={set("quantity")} data-testid={`${testid}-quantity`} />
      </label>
      <label className="sm:col-span-2 text-xs tracking-widest uppercase fs-text-2">Unit
        <input className="fs-input mt-1 normal-case tracking-normal" maxLength={24} value={f.unit} onChange={set("unit")} placeholder="jar, lb, dozen" data-testid={`${testid}-unit`} />
      </label>
      <label className="sm:col-span-2 text-xs tracking-widest uppercase fs-text-2">Category
        <select className="fs-input mt-1 normal-case tracking-normal" value={f.category} onChange={set("category")} data-testid={`${testid}-category`}>
          {LARDER_CATEGORIES.map(c => <option key={c}>{c}</option>)}
        </select>
      </label>
      <label className="sm:col-span-4 text-xs tracking-widest uppercase fs-text-2">Notes
        <input className="fs-input mt-1 normal-case tracking-normal" maxLength={500} value={f.notes} onChange={set("notes")} placeholder="Optional" data-testid={`${testid}-notes`} />
      </label>
      {stock && <>
        <label className="sm:col-span-2 text-xs tracking-widest uppercase fs-text-2">Low when at or below
          <input className="fs-input mt-1" type="number" min="0" step="any" value={f.low_at} onChange={set("low_at")} placeholder="Optional" data-testid={`${testid}-low-at`} />
        </label>
        <label className="sm:col-span-4 flex items-center gap-2 text-sm fs-text-2 self-end pb-2">
          <input type="checkbox" className="w-4 h-4" checked={f.remind} onChange={set("remind")} data-testid={`${testid}-remind`} />
          Remind me on Your Farmstand when this runs low (in-app only, no emails)
        </label>
      </>}
      <div className="sm:col-span-6 flex gap-2 justify-end">
        {onCancel && <button type="button" className="fs-btn-2" onClick={onCancel} data-testid={`${testid}-cancel`}>Cancel</button>}
        <button type="submit" className="fs-btn" disabled={busy || !f.name.trim()} data-testid={`${testid}-submit`}>{submitLabel || (initial ? "Save" : "Add to larder")}</button>
      </div>
    </form>
  );
}
